export default __webpack_public_path__ + "static/media/icon.non-perishable.cb658126.svg";